// extracted by mini-css-extract-plugin
export default {"planInfoPage":"PlanInfoPage_planInfoPage__7v+Tm"};